import React from "react";

import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import MDBadge from "components/MDBadge";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import DataTable from "examples/Tables/DataTable";
import EditInfos from "../EditInfos";

// Material Dashboard 2 PRO React contexts
import { useMaterialUIController } from "context";

import { useSelector } from "react-redux";
import { canEditOrder } from "../../../utils/permissions";

export default function InfosTable({ device, user }) {
  const currentOrder = useSelector((state) => state.orders.currentOrder);
  const canEdit = canEditOrder(user, currentOrder);
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const infosColumns = [
    { Header: "Procédure d'envoi", accessor: "invoice_procedure", align: "center" },
    { Header: "Paiement direct", accessor: "direct_payment", align: "center" },
    { Header: "TVA", accessor: "tva", align: "center" },
  ];
  const infosRows = [
    {
      direct_payment: (
        <MDBox display="flex" alignItems="center" lineHeight={1}>
          <MDBox lineHeight={1}>
            <MDBox ml={-1}>
              <MDBadge
                badgeContent={device && device.direct_payment}
                color={
                  device && device.direct_payment === "Non"
                    ? !darkMode
                      ? "dark"
                      : "light"
                    : "success"
                }
                variant="gradient"
                size="sm"
              />
              {device && device.direct_payment === "Oui" && (
                <MDTypography display="block" color="success" variant="button" fontWeight="medium">
                  {new Intl.NumberFormat("fr-FR").format(device && device.direct_payment_amount)}{" "}
                  euros
                </MDTypography>
              )}
            </MDBox>
          </MDBox>
        </MDBox>
      ),
      invoice_procedure: (
        <MDBox
          sx={(theme) => ({
            display: "block",
            whiteSpace: "normal",
            overflowWrap: "break-word",
            maxWidth: {
              xl: theme.breakpoints.values.sm - 100,
              lg: theme.breakpoints.values.sm - 150,
              md: theme.breakpoints.values.sm - 200,
              xs: theme.breakpoints.values.sm - 300,
            },
          })}
        >
          <MDTypography component="a" variant="button" fontWeight="medium">
            {device && device.invoice_procedure ? device.invoice_procedure : "Non spécifiée"}
          </MDTypography>
        </MDBox>
      ),
      tva: (
        <MDTypography component="a" variant="button" fontWeight="medium">
          {device && device.tva !== null ? device.tva + "%" : "Non spécifiée"}
        </MDTypography>
      ),
    },
  ];
  return (
    <Grid item xs={12} sx={{ height: "100% !important" }}>
      <Card sx={{ height: "100%" }}>
        <MDBox
          mx={2}
          mt={-3}
          py={1.5}
          px={2}
          variant="gradient"
          borderRadius="lg"
          sx={{
            background: !darkMode ? "linear-gradient(195deg, #364c70, #273956)" : "white",
            boxShadow: darkMode ? "0 1px 4px 1px white" : "0 1px 4px 1px #344767",
            display: "flex",
            verticalAlign: "middle",
          }}
        >
          <MDTypography
            variant="h5"
            style={{
              width: "50%",
              lineHeight: "2.4rem",
              display: "tableCell",
              verticalAlign: "middle",
            }}
            color={darkMode ? "inherit" : "white"}
          >
            Informations de facturation
          </MDTypography>
          {canEdit && (
              <Grid style={{ textAlign: "right", width: "50%" }}>
                <EditInfos device={device} edit={true} renderStep={0} />
              </Grid>
            )}
        </MDBox>
        <MDBox
          pt={0.75}
          sx={{
            height: "100%",
            "div.MuiTableContainer-root": {
              height: "100%",
              display: "flex",
            },
          }}
        >
          <DataTable
            table={{ columns: infosColumns, rows: infosRows }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={false}
            noEndBorder
          />
        </MDBox>
      </Card>
    </Grid>
  );
}
